import React, { useState } from "react";
import "./FormRadio.scss";
import RadioIcon from "../RadioIcon/RadioIcon";
import RequiredStar from "../RequiredStar/RequiredStar";
import { useDispatch } from "react-redux";
import { removeFormFieldError } from "../../redux/actions/contentActions";

function FormRadioButton(props) {
    function handleClick(key) {
        var newStates = [].concat(props.states);

        //activate
        for (var i = 0; i < props.numButtons; i++) {
            if (i == props.index) {
                newStates[i] = true;
            } else {
                newStates[i] = false;
            }
        }

        props.updateFormValue(props.radioButton);
        props.update(newStates);
    }

    var classes = "form-radio-button";
    classes += props.states[props.index] ? " active" : "";

    return (
        <label className={classes} onClick={(e) => handleClick(props.index)}>
            {props.radioButton.value}
            <input type="radio" value={props.radioButton.text} />
            <span className="checkmark"></span>
        </label>
    );
}

const FormRadio = (props) => {
    var [radioStates, setRadioStates] = useState([]);
    var dispatch = useDispatch();

    var classes = "form-radio";
    if (props.full) classes += " full";
    if (props.topPad) classes += " top-padding";
    if (props.error) classes += " error";

    function updateFormValue(radioButton) {
        var value = radioButton.text;
        props.setFormValue({ ...props.formValue, [props.name]: value });
        if (props.error) {
            dispatch(removeFormFieldError(props.index));
        }
    }

    const radioButtons = props.buttons;
    const radioButtonsList = radioButtons.map((radioButton, key) => (
        <FormRadioButton
            key={key}
            index={key}
            numButtons={radioButtons.length}
            radioButton={radioButton}
            name={radioButton.value}
            states={radioStates}
            updateFormValue={updateFormValue}
            update={setRadioStates}
        />
    ));

    return (
        <div className={classes}>
            <label className="radio-label">
                {props.label}
                {props.required && <RequiredStar />}
            </label>
            <div className="radio-buttons-list">{radioButtonsList}</div>
        </div>
    );
};

export default FormRadio;
